<template>
  <footer class="footer">
    <div class="container-fluid">
      <!-- <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/'}">Home</router-link>
          </li>
        </ul>
      </nav>-->
      <div class="copyright text-center">
        <a href="#" target="_blank">
          <img
            class="img-fluid logo-footer"
            src="@/assets/imgs/logo_atlantis.png"
            alt
            srcset
          /> </a
        >.
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.logo-footer {
  max-height: 25px;
}
</style>
